// Renewal requests are marked as shouldRenew if the question with ID "renewal" has been marked as true ("YES") in the renewalAssessment intake form
export const getIsRenewalCancelled = ({ isCompleted, shouldRenew }: { isCompleted: boolean; shouldRenew?: boolean | null }) => {
  // Note: shouldRenew is a nullable boolean - we should only return this stage if shouldRenew has been specifically marked as false
  return isCompleted && shouldRenew === false
}
